import React, {useEffect} from 'react';
import {StyleSheet, Platform, ScrollView} from 'react-native';
import {useForm, Controller} from 'react-hook-form';
import TextInput from '../../components/TextInput';
import Error from '../../components/Error';
import Button from '../../components/Button';
import SelectInput from '../../components/SelectInput';
import {
  anneeIFData,
  logement_socialData,
  communes_fiscalesDataNames,
  destination_proprieteData,
} from './data';
import {calculIF} from './calcul';
import {isNotDefaultSelect, isPositiveNumber} from '../../utils';

const FormIF = ({setAssiete, setMif, setCac, setTotal, jumpTo}) => {
  const {register, handleSubmit, control, errors, watch} = useForm({
    mode: 'onChange',
    defaultValues: {
      anneeIF: anneeIFData[0].value,
      logement_social: logement_socialData[1].value,
      commune_fiscale: communes_fiscalesDataNames[0].value,
      destination_propriete: destination_proprieteData[0].value,
      valeur_propriete: 0,
      loyer_propriete: 0,
    },
  });

  const onSubmit = (values) => {
    const total = calculIF(values);
    setAssiete(total.assietteImpotResult);
    setMif(total.montantImpotFoncierResult);
    setCac(total.montantCacResult);
    setTotal(total.montantTotal);
    jumpTo ? jumpTo('second') : '';
  };

  const destination_propriete = watch('destination_propriete');
  const valeur_propriete = watch('valeur_propriete');
  const loyer_propriete = watch('loyer_propriete');

  useEffect(() => {
    register('anneeIF', {
      required: true,
      validate: (value) => isNotDefaultSelect(value),
    });

    register('logement_social', {
      required: true,
      validate: (value) => isNotDefaultSelect(value),
    });

    register('commune_fiscale', {
      required: true,
      validate: (value) => isNotDefaultSelect(value),
    });

    register('destination_propriete', {
      required: true,
      validate: (value) => isNotDefaultSelect(value),
    });

    register('valeur_propriete');
    register('loyer_propriete');
  }, [register]);

  return (
    <ScrollView>
      <Controller
        control={control}
        name="anneeIF"
        render={(props) => (
          <SelectInput
            selectedValue={props.value}
            onValueChange={props.onChange}
            label="Année de l'impot foncier"
            data={anneeIFData}
          />
        )}
      />
      {errors.anneeIF?.type === 'required' && (
        <Error>Ce champ est obligatoire !</Error>
      )}

      {errors.anneeIF?.type === 'validate' && (
        <Error>Veuillez choisir une valeur !</Error>
      )}

      <Controller
        control={control}
        name="logement_social"
        render={(props) => (
          <SelectInput
            selectedValue={props.value}
            onValueChange={props.onChange}
            label="Logement social"
            data={logement_socialData}
          />
        )}
      />
      {errors.logement_social?.type === 'required' && (
        <Error>Ce champ est obligatoire !</Error>
      )}

      {errors.logement_social?.type === 'validate' && (
        <Error>Veuillez choisir une valeur !</Error>
      )}

      <Controller
        control={control}
        name="commune_fiscale"
        render={(props) => (
          <SelectInput
            selectedValue={props.value}
            onValueChange={props.onChange}
            label="Commune fiscale de la propriété bâtie"
            data={communes_fiscalesDataNames}
          />
        )}
      />
      {errors.commune_fiscale?.type === 'required' && (
        <Error>Ce champ est obligatoire !</Error>
      )}

      {errors.commune_fiscale?.type === 'validate' && (
        <Error>Veuillez choisir une valeur !</Error>
      )}

      <Controller
        control={control}
        name="destination_propriete"
        render={(props) => (
          <SelectInput
            selectedValue={props.value}
            onValueChange={props.onChange}
            label="Destination de la propriété bâtie"
            data={destination_proprieteData}
          />
        )}
      />

      {errors.destination_propriete?.type === 'required' && (
        <Error>Ce champ est obligatoire !</Error>
      )}

      {errors.destination_propriete?.type === 'validate' && (
        <Error>Veuillez choisir une valeur !</Error>
      )}

      {['habitation_principale', 'habitation_secondaire', 'gratuit'].includes(
        destination_propriete,
      ) && (
        <>
          <Controller
            control={control}
            name="valeur_propriete"
            render={(props) => (
              <TextInput
                onChangeText={props.onChange}
                value={props.value}
                label={`Valeur vénale de la propriété : ${valeur_propriete}`}
                placeholder="Veuillez entrer une valeur"
                keyboardType={Platform.OS === 'ios' ? 'number-pad' : 'numeric'}
              />
            )}
            rules={{
              required: true,
              validate: (value) => isPositiveNumber(value),
            }}
          />

          {errors.valeur_propriete?.type === 'required' && (
            <Error>Ce champ est obligatoire !</Error>
          )}

          {errors.valeur_propriete?.type === 'validate' && (
            <Error>Ce champ doit être un entier positif !</Error>
          )}
        </>
      )}

      {['location_meublee', 'location_non_meublee'].includes(
        destination_propriete,
      ) && (
        <>
          <Controller
            control={control}
            name="loyer_propriete"
            render={(props) => (
              <TextInput
                onChangeText={props.onChange}
                value={props.value}
                label={`Montant des loyers annuels N : ${loyer_propriete}`}
                placeholder="Veuillez entrer une valeur"
                keyboardType={Platform.OS === 'ios' ? 'number-pad' : 'numeric'}
              />
            )}
            rules={{
              required: true,
              validate: (value) => isPositiveNumber(value),
            }}
          />

          {errors.loyer_propriete?.type === 'required' && (
            <Error>Ce champ est obligatoire !</Error>
          )}

          {errors.loyer_propriete?.type === 'validate' && (
            <Error>Ce champ doit être un entier positif !</Error>
          )}
        </>
      )}
      <Button onPress={handleSubmit(onSubmit)} label="Faire la simulation" />
    </ScrollView>
  );
};

const styles = StyleSheet.create({});

export default FormIF;
